import { useEagerKeyboardVisibleListeners } from "#eager-keyboard-visible";

/**
 * Mount once at the app root so eager keyboard visibility listeners are
 * registered without top-level module side effects.
 */
export function useCollapsiblePersistentKeyboard() {
  useEagerKeyboardVisibleListeners();
}
